"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vietnamTranslations = void 0;
var _types = require("../../../types");
const vietnamTranslations = exports.vietnamTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Thành thật xin lỗi!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Quay lại',
  [_types.ErrorPageTranslationKey.text]: 'Trang nội dung hiện không thể hiển thị vào lúc này.',
  [_types.ErrorPageTranslationKey.notFound]: 'Trang yêu cầu của bạn không được tìm thấy',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Trang bạn đang cố truy cập bị hạn chế và không phải tất cả tiêu chí đều được đáp ứng.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Vui lòng liên hệ với đội ngũ hỗ trợ của Oriflame qua email:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'URL được yêu cầu đã bị từ chối!'
};
